var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "上传自留ISA",
        visible: _vm.dialogVisible,
        width: "520px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "div",
            { staticClass: "upload" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: "#",
                    "list-type": "picture",
                    "http-request": _vm.httpRequest,
                    "show-file-list": false,
                  },
                },
                [
                  _c("svg-icon", {
                    attrs: { iconClass: "upload", className: "icon" },
                  }),
                  _c("p", { staticClass: "p1" }, [
                    _vm._v("拖拽你的文件到此处"),
                  ]),
                  _c("p", { staticClass: "p2" }, [_vm._v("或")]),
                  _c("div", { staticClass: "btn" }, [_vm._v("点击上传")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.file,
                  expression: "file",
                },
              ],
              staticClass: "fileLists",
            },
            [
              _c(
                "div",
                {
                  staticClass: "item-upload-area",
                  style: {
                    visibility:
                      _vm.file && _vm.file.name ? "visible" : "hidden",
                  },
                },
                [
                  _c("div", [
                    _c("img", {
                      attrs: { src: require("@/assets/images/const/xlsx.png") },
                    }),
                    _c("div", { staticClass: "des" }, [
                      _c("p", { staticClass: "fileName" }, [
                        _vm._v(_vm._s(_vm.file && _vm.file.name)),
                      ]),
                      _c("p", { staticClass: "fileSize" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatSize")(_vm.file && _vm.file.size)
                          ) + " mb"
                        ),
                      ]),
                    ]),
                  ]),
                  _c("i", { staticClass: "el-icon-circle-check" }),
                ]
              ),
            ]
          ),
        ]
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "ok flex_c_c",
              on: { click: _vm.ok },
            },
            [_vm._v("确定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }